export default {
  GET_TOKENS_REQUESTED: 'GET_TOKENS_REQUESTED',
  GET_TOKENS_FAILED: 'GET_TOKENS_FAILED',
  GET_TOKENS_SUCCEEDED: 'GET_TOKENS_SUCCEEDED',
};
